export default "__VITE_ASSET__BVfrmBYN__"